export class Url {

    static isRelativeUrl(url) {
        return url.substr(0, 2) !== '//' && url.indexOf('://') === -1;
    }

    static to(url) {
        if(this.isRelativeUrl(url)) {
            url = window.location.protocol + '//' + window.location.host + '/' + url;
        }

        return url.replace(/(?<!:)\/{2}/,'/');
    }
}